import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  CreateCustomerInvoiceApi,
  GetStockStatsApi,
  GetCustomerInvoiceApi,
  GetCustomerInvoiceByIdApi,
  GetCustomerPaymentByIdApi,
} from "../../ApiRequests";

export const fetchCustomerPayments = createAsyncThunk(
  "fetch/CustomerPayments",
  async (id) => {
    try {
      let response;
      if (id) response = await GetCustomerPaymentByIdApi(id);
      else response = await GetCustomerInvoiceApi();

      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const CustomerPaymentSlice = createSlice({
  name: "CustomerPayment",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerPayments.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCustomerPayments.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchCustomerPayments.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default CustomerPaymentSlice.reducer;
